import * as Action from '../actions/index';
export const initialState = {
  token: null,
  user: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case Action.LOGIN:
      return {
        ...state,
        token: action.payload.token,
        user: action.payload.user,
      };
    case Action.REGISTER:
      return state;
    case Action.LOGOUT:
      return {
        token: null,
        user: null,
        error: null,
      };
    default:
      return state;
  }
};
export default reducer;
